import React, { useState, useEffect } from "react";
import ChatService from "../../services/ChatService";

import { useDispatch } from "react-redux";

const ChatHistoryFooter = ({ chatRoomId, userInfo }) => {
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");
  const [toggleEmojis, setToggleEmojis] = useState(false);
  // Gửi tin nhắn
  const handleSendMessage = async () => {
    if (!message.trim()) return;

    await ChatService.sendMessage(chatRoomId, userInfo.id, message);
    setMessage("");
  };
  const handleEmojiClick = (emoji) => {
    setMessage((prev) => prev + emoji); // Thêm emoji vào cuối message
  };
  return (
    <div className="card-footer border-0">
      <div className="d-flex align-items-center">
        <div className="d-flex align-items-center chat-input-icons">
          <a className="btn no-bg" href="#" data-bs-toggle="dropdown">
            <i className="ti ti-dots-vertical"></i>
          </a>
          <div className="dropdown-menu dropdown-menu-end p-3">
            <a href="#" className="dropdown-item">
              <i className="isax isax-camera me-2"></i>Camera
            </a>
            <a href="#" className="dropdown-item">
              <i className="isax isax-gallery me-2"></i>Gallery
            </a>
            <a href="#" className="dropdown-item">
              <i className="isax isax-audio-square me-2"></i>Audio
            </a>
            <a href="#" className="dropdown-item">
              <i className="isax isax-location me-2"></i>Location
            </a>
            <a href="#" className="dropdown-item">
              <i className="isax isax-user-cirlce-add me-2"></i>Contact
            </a>
          </div>
          <div className="form-item emoj-action-foot">
            <a
              href="#"
              className="action-circle"
              onClick={(e) => {
                e.preventDefault();
                setToggleEmojis(!toggleEmojis);
              }}
            >
              <i className="fa-regular fa-face-smile"></i>
            </a>
            <div
              className="emoj-group-list-foot down-emoji-circle"
              style={{ display: toggleEmojis ? "block" : "none" }}
            >
              <ul>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleEmojiClick("😀");
                    }}
                  >
                    <img src="assets/img/icons/emonji-02.svg" alt="Icon" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleEmojiClick("🥰");
                    }}
                  >
                    <img src="assets/img/icons/emonji-05.svg" alt="Icon" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleEmojiClick("😍");
                    }}
                  >
                    <img src="assets/img/icons/emonji-06.svg" alt="Icon" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleEmojiClick("🤩");
                    }}
                  >
                    <img src="assets/img/icons/emonji-07.svg" alt="Icon" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleEmojiClick("😝");
                    }}
                  >
                    <img src="assets/img/icons/emonji-08.svg" alt="Icon" />
                  </a>
                </li>
                <li className="add-emoj">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <i className="isax isax-add"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <a href="#">
            <i className="isax isax-microphone-2"></i>
          </a>
        </div>
        <div className="chat-input me-2">
          <input
            className="form-control"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSendMessage();
              }
            }}
            placeholder="Type your message here..."
          />
        </div>
        <div>
          <button
            className="btn btn-primary btn_send"
            onClick={handleSendMessage}
          >
            <i className="isax isax-send-25 text-white" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatHistoryFooter;
